import styled from "@emotion/styled";
import { BRAND_UI_TYPES } from "./constants";
import { SEARCH_INPUT_WIDTH } from "shared/components/Header/DesktopHeader/components/Menu/components/Category/components/Brands/constants";

export const InitialsContainer = styled.div`
    height: 32px;
    width: calc(100% - ${SEARCH_INPUT_WIDTH}px);
    align-items: center;
    margin-bottom: 25px;
    display: flex;
    padding: 0 10px;
`;

export const BrandInitials = styled.span<{ brandUIType: number }>`
    width: 10px;
    height: 18px;
    font-size: 14px;
    line-height: 3;
    letter-spacing: -0.23px;
    color: #999999;
    flex-grow: 1;
    font-weight: 100;
    text-align: center;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    ${props => props.brandUIType === BRAND_UI_TYPES.AVAILABLE && `color: #000`}
    ${props =>
        props.brandUIType === BRAND_UI_TYPES.SELECTED &&
        `
        color: #000;
        font-weight: 500;

        &:after {
            position: absolute;
            content: "";
            height: 2px;
            bottom: -2px;
            left: 0;
            right: 0;
            background: #000;
        }`}
`;
